import { Helmet } from 'react-helmet-async';
import Header from '../GlobalComponents/Funtion-Header/Header';
import TableView from '../GlobalComponents/TableView/TableView';
import apiMiddleware from '../Utility/middleware';
import React, { useEffect, useState } from 'react';
import ConfirmDialog from'../GlobalComponents/Alert/ConfirmDailog';
import Loader from '../GlobalComponents/Loader/Loader';
import ExcelDownload from '../GlobalComponents/Download/ExelDownload';
import MaintenancePopup from "../GlobalComponents/Shedule-Maintanc/MaintannacePoup";
import { format } from 'date-fns';
import Alert from "../GlobalComponents/Shedule-Maintanc/AlertPopUP";
import PDFDownload from '../GlobalComponents/Download/PDFDownload';
import schedulePingRequest from '../Utility/Sheduler';
import axios from 'axios';
import { IoEye } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { SiStatuspal } from "react-icons/si";
import DevicesGet from '../Utility/DevicesGet';
const headers = [

  {
    key: 'View',
    label: <IoEye size={25}/>,
    render: (row) => (
        <Link to={`/diagnostics-history/${row.device_ip}`}>
         <IoEye size={25}/>
         <p className=' hidden'>{row.device_ip}</p>
         </Link>
    ),
},
  { key: 'device_ip', label: 'IP Address' },
  {
    key: "version",
    label: "Device Status",
    render: (row) => {
      return row.Running_status === "Completed" && row.Device_status === "Healthy" && row.device_working_status === "Warning" ? (
        <span className="text-yellow-400 font-semibold">Warning.</span>
      ) : row.Running_status === "Completed" && row.Device_status === "Healthy" ? (
        <span className="text-green-400 font-semibold">Completed.</span>
      ) : row.Running_status === "Completed" && row.Device_status === "Unresponsive" ? (
        <span className="text-red-500 font-semibold">Unresponsive.</span>
      ) : (
        <span className="text-gray-400 font-semibold">Delayed.</span> // Fallback case
      );
    },
  }
,  
  {
    key:'device_working_status', label: 'Running Status'
  },
  { key: 'Device_location', label: 'Device location' },
  
  { key: 'updated_at', label: 'Run On' ,
    render: (row) => format(new Date(row.updated_at), 'dd/MM/yyyy hh:mm a')
  },
  
  { key: 'created_by', label: 'Run By' }
];


const headersPDF = [

  { key: 'device_ip', label: 'IP Address' },
  { key: 'Device_status', label: 'Status' },
  {
    key:'device_working_status', label: 'Running Status'
  },
  { key: 'Device_location', label: 'Device location' },
  { key: 'updated_at', label: 'Run On' ,
    render: (row) => format(new Date(row.updated_at), 'dd/MM/yyyy hh:mm a')
  },
  
  { key: 'created_by', label: 'Run By' }
];











const PDUheader =[

//   {
//     key: 'View',
//     label: <IoEye size={25}/>,
//     render: (row) => (
//         <Link to={`/maintenance-schedules/${row.ip_address}`}>
//          <IoEye size={25}/>
//          <p className=' hidden'>{row.ip_address}</p>
//          </Link>
//     ),
// },
{
  key: 'health',
  label: <SiStatuspal size={25}/>,
  render: (row) => (
    <span
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${row.health.overall === 'Good' ? 'bg-green-500' :
        row.health.overall === 'Critical' ? 'bg-red-500' :
          row.health.overall === 'Warning' ? 'bg-yellow-500' : 'bg-gray-500'
        } text-white`}

      title={`${row.health.overall} || ${row.health.connectivity_explanation}`}
    >
      <p className={`hidden`}>
        {row.health.overall}
      </p>
    </span>
  ),
},
{ key: 'ip_address', label: 'IP Address'},
  { key: 'model', label: 'Model Name'},
 
  { key: 'location', label: 'Device Location'
    
  },
  { key: 'description', label: 'Description'},
  { key: 'manufacturer', label: 'Manufacturer'},
  { key: 'caption', label: 'Room Name'},
 

]


const AVheader = [
//   {
//     key: 'View',
//     label: <IoEye size={25}/>,
//     render: (row) => (
//         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
//          <IoEye size={25}/>
//          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
//          </Link>
//     ),
// },
{
  key: 'Status',
  label: <SiStatuspal size={25}/>,
  render: (row) => {
    const statusClass =
      row.Status === 'Active' ? 'bg-green-500' :
      row.Status === 'Missing' ? 'bg-red-500' :
      'bg-gray-400'; // Default class if the status doesn't match any condition

    return (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${statusClass} text-white`}
        title={row.Status}
      >
        <p className="hidden">
          {row.Status === 'Active' ? 'ONLINE' : 'OFFLINE'}
        </p>
      </span>
    );
  },
},
{ key: 'NetworkSettings',
  label: 'IP Address',
 
  render: (row) => (
    <span className="">
      {row.NetworkSettings.IPAddress}
    </span>
  )
  },
  {
    key: 'ControllerName', label: 'Controller Name'
  },
  {
    key: 'RoomId', label: 'Room ID'
  },
  {
    key: 'ControllerType', label: 'Controller Type'
  },
  {
    key: 'ModelName', label: 'Model Name'
  },


]








/// PDF and XEL EXPORT settings Headers

const AVPDFheader = [
  //   {
  //     key: 'View',
  //     label: <IoEye size={25}/>,
  //     render: (row) => (
  //         <Link to={`/maintenance-schedules/${row.NetworkSettings.IPAddress}`}>
  //          <IoEye size={25}/>
  //          <p className=' hidden'>{row.NetworkSettings.IPAddress}</p>
  //          </Link>
  //     ),
  // },
  {
    key: 'Status',
    label: 'Device Status'
  },
  { key: 'NetworkSettings.IPAddress',
    label: 'IP Address',
    },
    {
      key: 'ControllerName', label: 'Controller Name'
    },
    {
      key: 'RoomId', label: 'Room ID'
    },
    {
      key: 'ControllerType', label: 'Controller Type'
    },
    {
      key: 'ModelName', label: 'Model Name'
    },
  
  
  ]


  const PDUPDFheader =[

    //   {
    //     key: 'View',
    //     label: <IoEye size={25}/>,
    //     render: (row) => (
    //         <Link to={`/maintenance-schedules/${row.ip_address}`}>
    //          <IoEye size={25}/>
    //          <p className=' hidden'>{row.ip_address}</p>
    //          </Link>
    //     ),
    // },
    {
      key: 'health.overall',
      label:'Health'
    },
    { key: 'ip_address', label: 'IP Address'},
      { key: 'model', label: 'Model'},
     
      { key: 'location', label: 'Device Location'},
      { key: 'description', label: 'Description'},
      { key: 'manufacturer', label: 'Manufacturer'},
      { key: 'caption', label: 'Room Name'},
     
    
    ]





const Diagnostics = () => {
  const [Devices, setDevices] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selecteFilter, setSelecteFilter] = useState('av');
  const [isOpen, setIsOpen] = useState(false);
  const [SearchTerm, setSearchTerm] = useState('');

  const [loading, setLoading] = useState(false);

  const [Heading, setHeading] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [AlertData, setAlertData] = useState([]);

  useEffect(() => {




    setLoading(true)
    const handleCrudOperation = async () => {
      const body = {
        queryType: 'custom-query',
        table: 'DevicesPing_Log',
        data: {
          query: `SELECT * 
FROM DevicesPing_Log
WHERE Running_status = 'Completed' 
ORDER BY id DESC`,
        }
      }

      const response = await apiMiddleware('POST', body);





      if (response.success) {
        setLoading(false)
        setDevices(response.data);

        console.log(response)
      } else {
        console.error('CRUD Operation Failed:', response.error);
      }
    };

    setLoading(true);
  

    handleCrudOperation();

    
  }, [])

  useEffect(() =>{
    setLoading(true);
    fetchDevicesdata();
  },[Devices])



const [pduData, setPduData] = useState([]);
  const [avData, setAvData] = useState([]);
  const [smartSwitchData, setSmartSwitchData] = useState([]);




  // console.log("PDU",pduData)
  // console.log("AV",avData)

  const fetchDevicesdata = async () => {
    setLoading(true)
    try {
     
   
        const AVdevice = await DevicesGet("/AV");
      
        // console.log(AVdevice)
        if (AVdevice.success === false) {
          console.error("Failed to fetch device data:", AVdevice.error);
          return;
        }


        const PDUevice = await DevicesGet("/PDU");
      
        if (PDUevice.success === false) {
          console.error("Failed to fetch device data:", PDUevice.error);
          return;
        }
      
   

  
        const mergedAVData = Devices.map(log => {
          const AVData = AVdevice?.Controllers?.find(
            controller => Number(controller.ControllerId) === Number(log.device_id) &&
                          controller?.NetworkSettings?.IPAddress === log.device_ip
          ) || {}; // Fallback to empty object to avoid errors
        
          return {
            ...log,
            ...AVData, // Merging AV Data if found
          };
        });
        
        console.log("Merged Data", mergedAVData);
        
        

        const mergedPDUData = Devices.map(log => {
          const pduData = PDUevice.pdus?.find(
            pdu => Number(pdu.id) === Number(log.device_id) &&
                   pdu.ip_address === log.device_ip
          ) || {}; // Fallback to empty object to avoid errors
        
          return {
            ...log,
            ...pduData, // Merging PDU data if found
          };
        });
        
        console.log("Merged PDU Data", mergedPDUData);
        

      // Update the respective states with the data
      setPduData(mergedPDUData);
      setAvData(mergedAVData);

      
      // setSmartSwitchData(smartSwitchResponse.data);
    } catch (err) {
      console.error('Error fetching data:', err);
      // setError(err);
    } finally {
      setLoading(false);
    }
  };











  


  const handleSearchChange = (Data) => {

    setSearchTerm(Data);
  };


  const handleonDeviceSelect = (selectedData) => {
    setSelecteFilter(selectedData);

    

  };



  const handleRowSelectionChange = (selectedData) => {
    setSelectedRows(selectedData);
  };



  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [Download, setDownload] = useState('');

  
  const FunctionBTN = (btn) => {
    if (selectedRows.length <= 0) {

     setShowAlert(true);
     setAlertData([

       {
         type: 'hold',
         title: 'No Device Selected',
         message: 'Please select at least one device to download the file.'
       }
     ])

     return;
   }
   setDownload(btn);
   setIsDialogOpen(true)
 }



 const handleDownload = () => {
    
  setIsDialogOpen(false)
 



      if (Download === 'excel') {
        // Check for the 'av' filter and call ExcelDownload
        if (selecteFilter === 'av') {
          ExcelDownload({ headers: headersPDF, rows: selectedRows, filename: 'av-data.xlsx' });
        }

        if (selecteFilter === 'pdu') {
          ExcelDownload({ headers: headersPDF, rows: selectedRows, filename: 'PDU-data.xlsx' });
        }




      }

      if (Download === 'pdf') {

        if (selecteFilter === 'av') {
        PDFDownload({ headers: headersPDF, rows: selectedRows,Name:"AV Devices", filename: "AV_REport.pdf" })
      }
    
      if (selecteFilter === 'pdu') {
        PDFDownload({ headers: headersPDF, rows: selectedRows,Name:"PDU Devices", filename: "PDU_report.pdf" })

      }
    
    
    }
    
    // Directly call the ExcelDownload function to trigger the download
   


  };





  const handleRunSelfDiagnostics = () => {
    setHeading('Self Diagnostics');
    setIsOpen(true)


  };

  const SheduledProcessDateTime = async (date, actionType) => {



    // First, install date-fns
    // npm install date-fns


    const formattedDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');








    if (actionType === 'run') {
      // const body = {
      //   "route": "http://localhost:3500/api/ping/batch",
      //   "headers": {

      //   },
      //   "body": {
      //     "ips": selectedRows.map((data) => data.HOST_IP),
      //     "numPings": 4
      //   },
      //   "run_at": formattedDate
      // }

      // ;

      // const response = await apiMiddleware('/scheduler/schedule', 'POST', body);

      // if (response.success) {

      //   console.log(response);
      //   setShowAlert(true);

      // } else {
      //   console.error('CRUD Operation Failed:', response.error);
      // }




      const ips = selectedRows.map((data) => data.HOST_IP);

      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, formattedDate)
        .then(data => {


          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance Started!',
              message: 'Maintenance Run Task Added'
            }
          ])


          setShowAlert(true);
        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });





    }
    else if (actionType === 'schedule') {

      const ips = selectedRows.map((data) => data.HOST_IP);

      // Call the middleware function with the IPs and runAt time
      schedulePingRequest(ips, date)
        .then(data => {


          setAlertData([

            {
              type: 'success',
              title: 'Hurray! Maintenance scheduled!',
              message: 'Maintenance Will Run on ' + date
            }
          ])


          setShowAlert(true);
        })
        .catch(error => {
          console.error(error.message);
          alert('Failed to schedule ping request');
        });












    }


  };






  const handleRunMaintenance = (data) => {
    setHeading('Maintenance')
    setIsOpen(true)



  };



   // Filter function for both PDU and AV data
   const filteredData = Devices.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(SearchTerm.toLowerCase())
    )
  );


  const ArrayData = filteredData.filter((item) => item.Device_Type === selecteFilter)




  return (


    <>

      <Helmet>
        <title>Device Management</title>
      </Helmet>

      <section className="bg-SoftBlack h-auto md:mt-0 mt-16">
        <MaintenancePopup heading={Heading} SheduledProcessDateTime={SheduledProcessDateTime} isOpen={isOpen} onClose={() => setIsOpen(false)} />
        {
          loading && <Loader />
        }


        {showAlert && (
          <Alert
            type={AlertData[0]?.type} // or "info" based on your needs
            title={AlertData[0]?.title}
            message={AlertData[0]?.message}
            onCloseAlert={() => setShowAlert(false)}
          />
        )}
           <ConfirmDialog
                isOpen={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onConfirm={handleDownload}
                title="Confirm Download"
                message="Are you sure you want to download this file?"
              />

        <Header selectedRows={selectedRows || null} HideALLBTNS={true} handleRunSelfDiagnostics={handleRunSelfDiagnostics} handleRunMaintenance={handleRunMaintenance} onButtonClick={handleonDeviceSelect} onSearchChange={handleSearchChange} HeaderBTNCLICK={FunctionBTN} />
       
       
       {/* Handling the filter logic before rendering */}
      {selecteFilter === 'av' && (
       


        <>
     
        <TableView headers={headers} SHOWSETTINGTAB7={true} rows={ArrayData} onRowSelectionChange={handleRowSelectionChange} />
        </>
      )}
      {selecteFilter === 'pdu' && (
       <>
       
     
       <TableView headers={headers} SHOWSETTINGTAB7={true} rows={ArrayData} onRowSelectionChange={handleRowSelectionChange} />
       </>
      )}
      {selecteFilter === 'network' && (

        <>
       
         <TableView DataAvailabe={false} headers={headers} SHOWSETTINGTAB7={true} rows={[]} onRowSelectionChange={handleRowSelectionChange} />
        </>
       
        
      )}
       
       
       
      </section>
    </>




  );
}

export default Diagnostics;